import { Button, useTranslate } from "react-admin";
import CloseIcon from '@material-ui/icons/Close';

const CloseButton = ({ onClick }) => {
    const translate = useTranslate();
    return <Button className="CloseButton" title={translate("resources.close")} aria-label={translate("resources.close")} size="large" onClick={onClick}>
        <CloseIcon />
    </Button>
};

export default CloseButton;

